import styled from "styled-components";
import AddToBoxOrCartButton from "../../molecules/AddToBoxOrCartButton";
import breakpoints from "../../../styles/breakpoints";

const StyledAddToBoxOrCartButton = styled(AddToBoxOrCartButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: black;
  margin-left: 10px;
  margin-right: 1px;
  padding: 9px 10px;
  border: 1px solid black;
  &:hover,
  &:focus {
    background-color: white;
  }
  &:disabled {
    background-color: black;
    opacity: 1;
    cursor: pointer;
  }
  ${breakpoints.mdDown} {
    /* iPad and lower */
    padding: 8px 10px;
  }
`;

export default StyledAddToBoxOrCartButton;
